module.exports = __webpack_public_path__ + "static/media/amex.8b89f251.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/amex.svg
// module id = 723
// module chunks = 0